<div class="container">
  <div class="row">
    <div *ngIf="isCTT" class="col-md-12">
      <img class="boxer-logo" src="../../../../assets/images/boxer.png" alt="" />
      <img class="ctt-logo" src="../../../../assets/images/ctt.png" alt="" />
    </div>

    <div class="col-sm-6 col-md-4 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <h5 class="card-title text-center">Iniciar Sessão</h5>
          <form class="form-signin">
            <div *ngIf="!isCTT" class="input-group">
              <input type="username" id="username" class="form-control" [(ngModel)]="username"
                [ngModelOptions]="{standalone: true}" placeholder="Utilizador" required autofocus autocomplete>
            </div>

            <div *ngIf="!isCTT" class="input-group">
              <input [type]="fieldTextType ? 'text' : 'password'" id="password" class="form-control" [(ngModel)]="password"
                [ngModelOptions]="{standalone: true}" placeholder="Palavra passe" required>
                <!-- <div class="input-group-append"> -->
                  <span class="input-group-text" (mouseover)="toggleFieldTextType()" (mouseleave)="toggleFieldTextType()">
                    <i class="fa" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}" (mouseover)="toggleFieldTextType()" (mouseleave)="toggleFieldTextType()"></i>
                  </span>
               <!-- </div> -->
            </div>

            <div *ngIf="!isCTT" class="custom-control custom-checkbox mb-2 text-center"> </div>
            <button *ngIf="!isCTT" type="submit" class="btn btn-lg btn-alert btn-block button-auth-colors text-uppercase" (click)="login()"> Autenticar</button>
            <!-- <hr *ngIf="isCTT" /> -->
            <button *ngIf="isCTT" id="ms" type="submit" class="btn btn-block button-msauth-colors text-uppercase" (click)="loginAzureAD()"><img src="/assets/images/ms-signin.png" alt=""/></button>
            <div>
              <label class="alert">{{errorMessage}}</label>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-sm-6 text-left apoio-condutor">
      <!-- <h2>APOIO AO CONDUTOR</h2> -->
      <h2>&nbsp;</h2>
      <p>
        Para qualquer questão que tenha pode-nos contactar através:
      </p>
      <ul>
        <li>
          <span>Linha de Apoio ao Condutor <a href="tel:00351211569924"><strong>+351 211 569 924</strong></a></span>
          <p style="font-size: small;vertical-align: top;">(chamada para rede fixa nacional)</p>
        </li>
        <li>
          <p>Email: <a href="mailto:info@boxer.pt">info&#64;boxer.pt</a></p>
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 spacer">
    </div>
  </div>
</div>
